<template>
  <div class="index">
    <div class="index-con">
      <div class="router">
        <span>IRADSTM</span>
        <b>→</b>
        <span>{{ nav_title }}</span>
        <b v-if="nav_small_title">→</b>
        <span v-if="nav_small_title">{{ nav_small_title }}</span>
      </div>
      <div v-html="con" class="index-content"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nav_title: "",
      nav_small_title: "",
      nav_id: "",
      nav_pid: "",
      con: "",
      title: "",
      news_id: "",
    };
  },
  mounted() {
    console.log(this.$route.query.type, "---type");
    this.init();
  },
  watch: {
    $route(to, from) {
      this.init();
    },
  },
  methods: {
    init() {
      this.nav_title = this.$route.query.nav_title;
      this.nav_small_title = this.$route.query.nav_small_title;
      if (this.$route.query.type == "news1") {
        this.news_id = this.$route.query.news_id;
        this.getnewslist1();
      } else if (this.$route.query.type == "news2") {
        this.news_id = this.$route.query.news_id;
        this.getnewslist2();
      } else {
        this.nav_id = this.$route.query.nav_id;
        this.nav_pid = this.$route.query.nav_pid;
        this.getConFn();
      }
    },
    getConFn() {
      this.$http
        .nav_list({
          nav_id: this.nav_id,
          nav_pid: this.nav_pid,
        })
        .then((res) => {
          console.log(res.data, "nav");
          this.list = res.data;
          this.con = res.data[0].content;
          this.title = res.data[0].nav_title;
        });
    },
    getnewslist1() {
      this.$http.index_newslist1({ news_id: this.news_id }).then((res) => {
        console.log(res.data);
        this.con = res.data[0].news_content;
        this.title = res.data[0].news_title;
      });
    },
    getnewslist2() {
      this.$http.index_newslist2(this.news_id).then((res) => {
        this.con = res.data[0].news_content;
        this.title = res.data[0].news_title;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  min-height: 600px;
}

.router {
  display: flex;
  margin: 23px 0 31px;
  align-items: center;

  span {
    color: rgba(31, 31, 31, 0.5);
    font-family: Canaro, Arial, sans-serif;
    font-size: 14px;
    line-height: 1.8;
    font-weight: 400;
    white-space: nowrap;
    cursor: pointer;
  }

  b {
    color: #f9b033;
    font-weight: 400;
    margin: 0 10px;
  }

  span:nth-last-of-type(1) {
    color: #333;
  }
}

.box-title {
  position: relative;
  color: #5b965a;
  margin-bottom: 30px;
  width: 100%;
  margin-top: 50px;

  span {
    padding-bottom: 10px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    border-bottom: 6px solid #5b965a;
  }
}

.index-img {
  width: 100%;
  height: auto;
}


@media screen and (max-width: 768px) {
  .index-content {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RichText.vue